(function ($) {
    jQuery(window).load(function () {

    });

    jQuery(document).ready(function () {
        var bookingforms = $('.bookingform');
        bookingforms.each(function () {
            var args = $.extend(true, {}, window.accorBookingArgs);
            var bookingform = $(this);
            var more_fields_wrap = bookingform.find('.codes_wrap');

            //Read configuration from data-args
            var maybe_local_config = bookingform.data('args');
            if (maybe_local_config) {
                args = $.extend(args, maybe_local_config);
            }

            //Handle number of rooms
            var room_selector = bookingform.find('.rooms_select');

            setTabIndex(bookingform, -1);

            room_selector.change(function () {
                var val = parseInt(room_selector.val());
                // Handle going back to "no clear number of roomes selected"
                var isPlaceHolder = (room_selector[0].selectedIndex === 0);
                if (isPlaceHolder) {
                    hide_inner_wrap(more_fields_wrap);
                } else {
                    show_inner_wrap(more_fields_wrap);
                }
                for (var i = 1; i <= args.maxrooms; i++) {
                    var selector = '.room_' + i + '_wrap';
                    var room_wrap = bookingform.find(selector);
                    if (i <= val && !isPlaceHolder) {
                        show_inner_wrap(room_wrap);
                    } else {
                        hide_inner_wrap(room_wrap);
                    }
                }
            });

            var children_selects = bookingform.find('.children_field select');
            children_selects.change(function () {
                var select = $(this);
                var this_room = select.closest('.room_wrap');
                var ages_wrap = this_room.find('.ages_wrap');
                var val = parseInt(select.val());
                var prev_val = select.data('prev_val') || 0;
                select.data('prev_val', val);
                if (val === 0) {
                    hide_inner_wrap(ages_wrap);
                } else {
                    if (ages_wrap.hasClass('vertical')) {
                        show_ages_wrap(ages_wrap, val, prev_val);
                    } else {
                        show_inner_wrap(ages_wrap);
                    }
                    for (var i = 1; i <= args.maxchildren; i++) {
                        var selector = '.child_' + i + '_field';
                        var single_age = ages_wrap.find(selector);
                        if (i <= val) {
                            show_child(single_age);
                        } else {
                            hide_child(single_age);
                        }
                    }
                }
            });

            handleDatepickers(bookingform);

            bookingform[0].addEventListener('de_booking_submitted', function () {
                hide_inner_wrap(more_fields_wrap);
                for (var i = 1; i <= args.maxrooms; i++) {
                    var selector = '.room_' + i + '_wrap';
                    var room_wrap = bookingform.find(selector);
                    hide_inner_wrap(room_wrap);
                }
                // Select the placeholder element
                room_selector[0].selectedIndex = 0;
            });

        });
    });

    function setTabIndex(selector, tabIndex = 0) {
        if (selector !== undefined) {
            if (selector.hasClass('bookingform_horizontal') || selector.hasClass('bookingform_vertical')) {
                selector.find('.wrap').not('.general_info_wrap').not('.submit_wrap').find('input,a,select,textarea').attr('tabindex', tabIndex);
            }
            if (selector.hasClass('room_wrap')) {
                var select_to_tabindex = selector.find('.adults_field, .children_field').find('select');
                select_to_tabindex.each(function () {
                    $(this).attr('tabindex', tabIndex);
                });

            } else if (selector.hasClass('ages_wrap')) {
                setTimeout(function () {
                    if (selector.hasClass('visible')) {
                        selector.find('.child_field.visible').eq(0).find('select').removeAttr('tabindex');
                    } else {
                        selector.find('.child_field.visible').eq(0).find('select').attr('tabindex', tabIndex);
                    }
                }, 1000);
            }

            if (selector.hasClass('child_field')) {
                selector.each(function () {
                    if ($(this).hasClass('visible')) {
                        $(this).find('select').removeAttr('tabindex');
                    } else {
                        $(this).find('select').attr('tabindex', tabIndex);
                    }
                });
            }

            if (selector.hasClass('codes_wrap')) {
                setTimeout(function () {
                    var input_to_tabindex = selector.find('input');
                    if (selector.hasClass('visible')) {
                        input_to_tabindex.each(function () {
                            $(this).removeAttr('tabindex');
                        });
                    } else {
                        input_to_tabindex.each(function () {
                            $(this).attr('tabindex', tabIndex);
                        });
                    }

                }, 1000);
            }

        }
    }

    function handleDatepickers(bookingform) {

        function resetDate(date) {
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);
            return date;
        }

        var checkinField = bookingform.find('input[name=checkInDate]');
        var checkoutField = bookingform.find('input[name=checkOutDate]');
        var checkinDP = bookingform.find('input[name=checkInDateDP]');
        var checkoutDP = bookingform.find('input[name=checkOutDateDP]');
        if (checkinField.length && checkinDP.length && checkoutField.length && checkoutDP.length) {
            var one_day = 86400000;
            var today = resetDate(new Date());
            var minCheckin = today;
            var maxCheckin = new Date(today.getTime() + 400 * one_day);
            var maxCheckout = new Date(today.getTime() + 401 * one_day);
            var timestamp;
            var dateFormatI18N = 'dd/mm/yy';
            if (checkinDP.data('dateformat')) {
                dateFormatI18N = checkinDP.data('dateformat');
            }
            if (checkinDP.data('mindate')) {
                timestamp = parseInt(checkinDP.data('mindate'));
                timestamp = !isNaN(timestamp) ? timestamp * 1000 : 0;
                if (timestamp > today) {
                    minCheckin = resetDate(new Date(timestamp));
                }
            }
            var minCheckout = new Date(minCheckin.getTime() + one_day);
            if (checkinDP.data('maxdate')) {
                timestamp = parseInt(checkinDP.data('maxdate'));
                timestamp = !isNaN(timestamp) ? timestamp * 1000 : 0;
                if (timestamp > minCheckout) {
                    maxCheckin = resetDate(new Date(timestamp));
                    maxCheckout = new Date(maxCheckin.getTime() + one_day);
                }
            }

            var currentCheckin = minCheckin;
            var currentCheckout = minCheckout;
            var checkinFormattedStd, checkinFormattedI18n, checkoutFormattedStd, checkoutFormattedI18n;

            function formatAndDisplayDates() {
                // TODO minStay, better handling of date i18n
                var i18nFormat = checkinDP.datepicker('option', 'dateFormat');

                checkinFormattedStd = $.datepicker.formatDate('dd/mm/yy', currentCheckin);
                checkinFormattedI18n = $.datepicker.formatDate(i18nFormat, currentCheckin);
                checkoutFormattedStd = $.datepicker.formatDate('dd/mm/yy', currentCheckout);
                checkoutFormattedI18n = $.datepicker.formatDate(i18nFormat, currentCheckout);

                checkinDP.val(checkinFormattedI18n);
                checkoutDP.val(checkoutFormattedI18n);

                checkinField.val(checkinFormattedStd);
                checkoutField.val(checkoutFormattedStd);
            }

            if (bookingform.hasClass('bookingform_horizontal')) {
                checkinDP.datepicker({
                    dateFormat: dateFormatI18N,
                    dayNamesMin: $.datepicker._defaults.dayNamesShort,
                    minDate: minCheckin,
                    maxDate: maxCheckin,
                    numberOfMonths: 2,
                    onSelect: function () {
                        currentCheckin = checkinDP.datepicker('getDate');
                        // if (currentCheckout <= currentCheckin) {
                        minCheckout = new Date(currentCheckin.getTime() + one_day);
                        currentCheckout = minCheckout;
                        checkoutDP.datepicker('option', 'minDate', minCheckout);
                        checkoutDP.datepicker('setDate', currentCheckout);
                        formatAndDisplayDates();
                        // }
                    }
                });

                checkoutDP.datepicker({
                    dateFormat: dateFormatI18N,
                    dayNamesMin: $.datepicker._defaults.dayNamesShort,
                    minDate: minCheckout,
                    maxDate: maxCheckout,
                    numberOfMonths: 2,
                    onSelect: function () {
                        currentCheckout = checkoutDP.datepicker('getDate');
                        formatAndDisplayDates();
                    }
                });
            } else {

                checkinDP.datepicker({
                    dateFormat: dateFormatI18N,
                    dayNamesMin: $.datepicker._defaults.dayNamesShort,
                    minDate: minCheckin,
                    maxDate: maxCheckin,
                    onSelect: function () {
                        currentCheckin = checkinDP.datepicker('getDate');
                        // if (currentCheckout <= currentCheckin) {
                        minCheckout = new Date(currentCheckin.getTime() + one_day);
                        currentCheckout = minCheckout;
                        checkoutDP.datepicker('option', 'minDate', minCheckout);
                        checkoutDP.datepicker('setDate', currentCheckout);
                        formatAndDisplayDates();
                        // }
                    }
                });

                checkoutDP.datepicker({
                    dateFormat: dateFormatI18N,
                    dayNamesMin: $.datepicker._defaults.dayNamesShort,
                    minDate: minCheckout,
                    maxDate: maxCheckout,
                    onSelect: function () {
                        currentCheckout = checkoutDP.datepicker('getDate');
                        formatAndDisplayDates();
                    }
                });
            }


            formatAndDisplayDates();
        } else {
            window.console && console.log('Bookingform without minimum date fields', bookingform);
        }
    }


    function show_ages_wrap(wrap, n_children, prev_val) {
        wrap.stop();
        var parent_inner_wraps = wrap.parents('.inner_wrap');
        var inner_wrap = wrap.find('> .inner_wrap');
        var single_age_height = inner_wrap.find('.child_field').eq(0).outerHeight();
        var previous_height = 0;
        if (prev_val > 0) {
            previous_height = wrap.outerHeight();
        }
        var verticalPadding = inner_wrap.outerHeight() - inner_wrap.height();
        var inner_wrap_height = inner_wrap.find('.title_field').outerHeight(true)
            + verticalPadding
            + (n_children * single_age_height);
        wrap.animate({
            height: inner_wrap_height
        }).addClass('visible');
        parent_inner_wraps.each(function () {
            var parent = $(this).parent();
            parent.stop();
            var height = parent.outerHeight() + inner_wrap_height - previous_height;
            parent.animate({
                height: height
            });
        });
        setTabIndex(wrap, 0);
    }


    function show_inner_wrap(wrap) {
        if (wrap.hasClass('visible')) {
            return;
        }
        wrap.stop();
        var parent_inner_wraps = wrap.parents('.inner_wrap');
        var inner_wrap = wrap.find('> .inner_wrap');
        var inner_wrap_height = inner_wrap.outerHeight();
        wrap.animate({
            height: inner_wrap_height
        }).addClass('visible');
        parent_inner_wraps.each(function () {
            var parent = $(this).parent();
            parent.stop();
            var height = parent.outerHeight() + inner_wrap_height;
            parent.animate({
                height: height
            });
        });
        setTabIndex(wrap, 0);
    }

    function hide_inner_wrap(wrap) {
        wrap.stop();
        var parent_inner_wraps = wrap.parents('.inner_wrap');
        var wrap_height = wrap.outerHeight();
        wrap.animate({
            height: 0
        }).removeClass('visible');
        parent_inner_wraps.each(function () {
            var parent = $(this).parent();
            parent.stop();
            var height = parent.outerHeight() - wrap_height;
            parent.animate({
                height: height
            });
        });
        setTabIndex(wrap, -1);
    }

    function show_child(wrap) {
        wrap.addClass('visible');
        setTabIndex(wrap, 0);
    }

    function hide_child(wrap) {
        wrap.removeClass('visible');
        setTabIndex(wrap, -1);
    }

})(jQuery);